import { createBlockStyleButton } from '@draft-js-plugins/buttons';
import { FormatListBulleted } from '@mui/icons-material';

const UnorderedListButton = createBlockStyleButton({
  blockType: 'unordered-list-item',
  children: <FormatListBulleted />,
});

export default UnorderedListButton;
